export const GROUP_START_MONTHS = 20;
export const DEAFULT_ALLOWED_MEMBERS = 10;
